/** Server may return typos like "VebSocket disconneeted". */
const WEBSOCKET_DISCONNECT_RE = /(?:veb|web)?socket.*disconne/i

export function isWebSocketDisconnectMessage(message?: string | null): boolean {
  if (!message) return false
  return WEBSOCKET_DISCONNECT_RE.test(message.trim())
}
